import { UTM_PARAMS } from "@/platform/api/constants"
import { readCookie } from "@/platform/browser/cookies"

const FULLY_SAMPLED_UTM_TERMS: readonly string[] = ["secured_phones_pilot_test", "secured_phones_pilot_dp0", "secured_phones_pilot_short", "secured_phones_pilot_short_dp0"]

// Meta sets its own per-ad utm_term and may suffix the campaign name, so the campaign matches as a substring.
const FULLY_SAMPLED_UTM_CAMPAIGN = "mktplace_users_paidsocial-facebook_sl_cph_10-2026"

const CAMPAIGN_UTM_TERM_PROPERTY = "campaign_utm_term"
const CAMPAIGN_UTM_CAMPAIGN_PROPERTY = "campaign_utm_campaign"

export interface FullySampledCampaign {
  term: string | null
  campaign: string | null
}

const orNull = (read: () => string | null): string | null => {
  try {
    return read()
  } catch {
    return null
  }
}

const stored = (param: string): string | null => orNull(() => localStorage.getItem(param)) || orNull(() => readCookie(param))

// RUM samples at init, before UtmParamStorage persists the landing URL, so the URL is read first. A landing
// that carries any UTM is a new click and is judged on its own params, never on an older stored campaign.
export const fullySampledCampaign = (): FullySampledCampaign | null => {
  const url = new URLSearchParams(window.location.search)
  const read = UTM_PARAMS.some((param) => url.has(param)) ? (param: string) => url.get(param) || null : stored
  const term = read("utm_term")
  const campaign = read("utm_campaign")
  const matches = (term !== null && FULLY_SAMPLED_UTM_TERMS.includes(term)) || campaign?.includes(FULLY_SAMPLED_UTM_CAMPAIGN)
  return matches ? { term, campaign } : null
}

export const campaignContext = ({ term, campaign }: FullySampledCampaign): Record<string, string> => ({
  ...(term && { [CAMPAIGN_UTM_TERM_PROPERTY]: term }),
  ...(campaign && { [CAMPAIGN_UTM_CAMPAIGN_PROPERTY]: campaign }),
})
